// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "./node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 200 200%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27noise%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.65%27 numOctaves=%273%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23noise%29%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimal CSS file for Vite build */

/* Always reserve the scrollbar gutter so locking body scroll when a modal
   opens (overflow: hidden) doesn't reflow the page or shift it sideways. */
html {
	scrollbar-gutter: stable;
}

/* Subtle paper texture effect */
.paper-texture {
	position: relative;
}

.paper-texture::before {
	content: "";
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
	z-index: 1;
	opacity: 0.12;
	background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

/* Dark mode adjustments */
.dark .paper-texture::before {
	opacity: 0.06;
	filter: invert(1);
}

/* Scroll offset for fixed header */
section[id] {
	scroll-margin-top: 120px;
}
`, "",{"version":3,"sources":["webpack://./index.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;2EAC2E;AAC3E;CACC,wBAAwB;AACzB;;AAEA,gCAAgC;AAChC;CACC,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,UAAU;CACV,aAAa;CACb,yDAA6T;AAC9T;;AAEA,0BAA0B;AAC1B;CACC,aAAa;CACb,iBAAiB;AAClB;;AAEA,mCAAmC;AACnC;CACC,wBAAwB;AACzB","sourcesContent":["/* Minimal CSS file for Vite build */\n\n/* Always reserve the scrollbar gutter so locking body scroll when a modal\n   opens (overflow: hidden) doesn't reflow the page or shift it sideways. */\nhtml {\n\tscrollbar-gutter: stable;\n}\n\n/* Subtle paper texture effect */\n.paper-texture {\n\tposition: relative;\n}\n\n.paper-texture::before {\n\tcontent: \"\";\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tpointer-events: none;\n\tz-index: 1;\n\topacity: 0.12;\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E\");\n}\n\n/* Dark mode adjustments */\n.dark .paper-texture::before {\n\topacity: 0.06;\n\tfilter: invert(1);\n}\n\n/* Scroll offset for fixed header */\nsection[id] {\n\tscroll-margin-top: 120px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
